import React, { FC, ReactElement } from 'react';

import AnonymousUserDisplay from 'buyside/components/presentation/AnonymousUserDisplay/anonymousUserDisplay';
import AnonEmployerAssociation from 'buyside/components/presentation/EmployerAssociation/anonEmployerAssociation';
import TinyIdeaCard, {
  SIZES
} from 'buyside/components/presentation/RankingsIndexPage/rankCard/TinyIdeaCard/tinyIdeaCard';
import Link from 'buyside/components/presentation/Link/link';

import { defaultUserImageUrl } from 'buyside/util/urlHelper';

import { Maybe } from 'interfaces/graphql-typings';

import styles from './rankingsWidgetItemStyles.scss';

const RankingsWidgetItem: FC<{
  anonAuthor: { title: string };
  employerProfileUrl: Maybe<string>;
  employerType: Maybe<string>;
  ideaUrl: string;
  isPairTrade: boolean;
  primarySymbols: string[];
  profileCity: string;
  publicUserIdeaUrl: Maybe<string>;
  rankNumber: number;
  showUserDetails: boolean;
  subtitle: string;
  totalReturn: number;
  userImageUrl: string;
  userName: string;
  userProfileUrl: string;
}> = ({
  anonAuthor,
  employerProfileUrl,
  employerType,
  ideaUrl,
  isPairTrade,
  primarySymbols,
  profileCity,
  publicUserIdeaUrl,
  rankNumber,
  showUserDetails,
  subtitle,
  totalReturn,
  userImageUrl,
  userName,
  userProfileUrl
}): ReactElement => {
  const Tag = employerProfileUrl ? 'a' : 'span';
  return (
    <li className={styles.container}>
      <div className={styles.userContainer}>
        <div className={styles.userImageContainer}>
          <a
            data-heap="rankings-widget-member-profile-picture"
            href={showUserDetails ? userProfileUrl : ''}
          >
            <img
              className={styles.userImage}
              src={showUserDetails ? userImageUrl : defaultUserImageUrl()}
            />
          </a>
          <div className={styles.rankNumber}>#{rankNumber}</div>
        </div>
        <div className={styles.userInfo}>
          {showUserDetails ? (
            <>
              <p>
                <a
                  data-heap="rankings-widget-member-profile"
                  className={styles.userName}
                  href={userProfileUrl}
                >
                  {userName}
                </a>
              </p>
              <p>
                <Tag
                  data-heap="rankings-widget-member-profile-employer"
                  className={styles.employerName}
                  href={employerProfileUrl || ''}
                >
                  {subtitle}
                </Tag>
              </p>
            </>
          ) : (
            <>
              <Link to={publicUserIdeaUrl}>
                <AnonymousUserDisplay anonUser={anonAuthor} />
              </Link>
              <AnonEmployerAssociation
                aumRange=""
                fundType={employerType}
                profileCity={profileCity}
                employerStyles={styles.anonEmployer}
                cityStyles={styles.anonEmployer}
              />
            </>
          )}
        </div>
      </div>
      <TinyIdeaCard
        primarySymbols={primarySymbols}
        totalReturn={totalReturn}
        ideaUrl={ideaUrl}
        isPairTrade={isPairTrade}
        size={SIZES.SMALLER}
        dataTag={'rankings-widget-view-idea'}
      />
    </li>
  );
};

export default RankingsWidgetItem;
